import React, { useEffect } from "react";
import styled from "@emotion/styled";

import LeftBar from "./components/LeftBar";
import Deskpad from "./components/Deskpad";
import TopBar from "./components/TopBar";
import SubtopBar from "./components/SubtopBar";
import BottomBar from "./components/BottomBar";

import Notify from "./Notifier";
import { useStoreon } from "storeon/react";

const isMobile = window.innerWidth < 480;

const Temp = styled.div`
  position: fixed;
  bottom: 0px;
  width: 100%;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #262626;
  > a {
    margin-right: 5px;
    color: white;
  }
`;

const App = () => {
  const { dispatch, products, config } = useStoreon("products", "config");
  useEffect(() => {
    dispatch("products/get");
    dispatch("config/get");
  }, [dispatch]);

  if (products === null || config === null) {
    return null;
  }

  return (
    <React.Fragment>
      <LeftBar />
      <TopBar />
      <SubtopBar />
      {!isMobile && <BottomBar />}
      <Deskpad />
      <Notify />
      <Temp>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.deskpad.de/impressum"
        >
          Impressum
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.deskpad.de/Datenschutz"
        >
          Datenschutz
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.deskpad.de/allgemeine_geschaeftsbedingungen/"
        >
          AGB
        </a>
      </Temp>
    </React.Fragment>
  );
};

export default App;
